export default function Manifesto() {
  return (
    <section id="manifesto" className="py-32 relative border-t border-white/5 bg-transparent">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <p className="text-xl md:text-2xl text-slate-400 font-light max-w-3xl mx-auto leading-normal">
          Recruitment isn't about keywords. It's about potential. We built an engine that
          listens, understands, and validates skill in real-time.{' '}
          <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent font-medium">Stop hiring without data or blindly.</span>
        </p>
      </div>
    </section>
  );
}
